import { AdvisingAbnormalOperationUserBean } from "./advising-abnormal-operation-user-bean";
import { AdvisingAbnormalTableHeaderUpdateBean } from "./advising-abnormal-table-header-update-bean";

export class AdvisingAbnormalTableHeaderUpdateRequest extends AdvisingAbnormalOperationUserBean {
  updatedHeaders: AdvisingAbnormalTableHeaderUpdateBean[];

  constructor() {
    super();
    this.updatedHeaders = [];
  }
}
